import { useRef, useState, useCallback, useEffect } from "react"
import cx from 'classnames'

import GFMap from "./gf-map/GFMap"
import GFList from "./gf-list/GFLIst"
import withGeofenceHOC from "../geofenceHOC"

import styles from './GFDashboard.module.css'
import { fetchGroupList } from "../../../../store/actions/groups"

const defaultMapConfig = {
    center: [
        20.5937,
        78.9629,
    ],
    zoom: 5,
    attributionControl: false,
    maxZoom: 22,
    minZoom: 5,
    zoomControl: false,
    enableMarkerCluster: true,
    zoomControlPosition: 'topright'
}

const GFDashboard = (props) => {
    const { masters, fenceTypeIconMap, geofences, mappedOptionsByVehicle, refreshGeofences } = props
    const fenceOwnerNamesByGeofences = [...new Set(geofences.map(fence => fence.fence_identifiers.owner_name))]

    const mapRef = useRef(null)
    const [mapConfig, setMapConfig] = useState(defaultMapConfig)
    const [groupList, setGroupList] = useState([]);

    const [filterData, setFilterData] = useState({
        searchText: '',
        citySelect: [],
        ownerTypeSelect: [],
        ownerNameSelect: [],
        fenceTypeSelect: '',
        isBaseFenceShown: false
    })

    useEffect(() => {
        const fetchGroupsList = async () => {
            const userId = JSON.parse(localStorage.getItem("user"))?._id;
            if (userId) {
                const result = await fetchGroupList(userId);
                setGroupList(result);
            }
        };
        fetchGroupsList()
        refreshGeofences()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const handleFilterChange = ({ name, value }) => {
        const newFilterData = { ...filterData }
        if (name === 'fenceTypeSelect') {
            if (newFilterData[name] === value) {
                newFilterData[name] = ''
            } else {
                newFilterData[name] = value
            }
        }
        else if (name === 'searchText') {
            newFilterData[name] = value
        } else if (name === 'isBaseFenceShown') {
            newFilterData[name] = value
        } else {
            if (newFilterData[name].includes(value)) {
                newFilterData[name] = newFilterData[name].filter(d => d !== value)
            } else {
                newFilterData[name].push(value)
            }
        }

        setFilterData({ ...newFilterData })
    }

    const filterFences = () => {
        const {
            searchText,
            citySelect,
            ownerTypeSelect,
            ownerNameSelect,
            fenceTypeSelect,
            isBaseFenceShown
        } = filterData

        const filtersCount = Object.values(filterData).filter(v => v.length || [true].includes(v)).length

        if (!filtersCount) {
            return geofences
        }

        return geofences.filter(fence => {
            let matchCount = 0

            if (
                (searchText.length && fence.fence_name.toLowerCase().includes(searchText.toLowerCase())) || 
                (searchText.length && fence?.baseDepot?.toLowerCase()?.includes(searchText.toLowerCase()))
            ) {
                matchCount += 1
            }

            // if (searchText.length && fence?.baseDepot?.toLowerCase()?.includes(searchText.toLowerCase())) {
            //     matchCount += 1
            // }

            if (isBaseFenceShown === true && fence?.baseDepot?.trim() !== '' && fence?.baseDepot !== null && fence?.baseDepot !== undefined) {
                matchCount += 1
            }

            if (citySelect.length && citySelect.includes(fence.fence_identifiers.city)) {
                matchCount += 1
            }

            if (ownerTypeSelect.length && ownerTypeSelect.includes(fence.fence_identifiers.owner_type)) {
                matchCount += 1
            }

            if (ownerNameSelect.length && ownerNameSelect.includes(fence.fence_identifiers.owner_name)) {
                matchCount += 1
            }

            if (fenceTypeSelect.length && fenceTypeSelect.includes(fence.fence_identifiers.fence_type)) {
                matchCount += 1
            }

            return matchCount === filtersCount
        })
    }

    const prepareFilters = () => {
        let filteredByCity = filterData.citySelect.length
        ? geofences.filter(fence => filterData.citySelect.includes(fence.fence_identifiers.city))
        : geofences

        let filteredByCityAndOwnerType = filterData.ownerTypeSelect.length
        ? filteredByCity.filter(fence => filterData.ownerTypeSelect.includes(fence.fence_identifiers.owner_type))
        : filteredByCity

        const ownerTypes = [...new Set(filteredByCity.map(fence => fence.fence_identifiers.owner_type))]

        const ownerNames = [...new Set(filteredByCityAndOwnerType.map(fence => fence.fence_identifiers.owner_name))]

        return  [{
            name: 'citySelect',
            label: 'City',
            options: mappedOptionsByVehicle.location,
        }, {
            name: 'ownerTypeSelect',
            label: 'Fence Owner Type',
            options: masters.FENCE_OWNER_TYPE.filter(type => ownerTypes.includes(type.value))
        }, {
            name: 'ownerNameSelect',
            label: 'Fence Owner Name',
            options: masters.FENCE_OWNER_NAME.filter(v => ownerNames.includes(v.value) && fenceOwnerNamesByGeofences.length && fenceOwnerNamesByGeofences.includes(v.value)).sort((a, b) => {
                if (a.value === 'OTHER') return 1
                if (b.value === 'OTHER') return -1
                return 0
            }),
        }]
        
    }

    const handleZoomClick = useCallback((control) => {
        const currentZoom = mapRef.current.getZoom()
        if (control === 'ZOOM_IN') {
            mapRef.current.setZoom(currentZoom + 1)
            setMapConfig({ ...mapConfig, zoom: currentZoom + 1 })
        }
        if (control === 'ZOOM_OUT') {
            mapRef.current.setZoom(currentZoom - 1)
            setMapConfig({ ...mapConfig, zoom: currentZoom - 1 })
        }
    }, [mapConfig, mapRef])

    const handleResetClick = useCallback(() => {
        setMapConfig({ ...defaultMapConfig })

        setFilterData({
            searchText: '',
            citySelect: [],
            ownerTypeSelect: [],
            ownerNameSelect: [],
            fenceTypeSelect: '',
        })

        mapRef.current.setView(defaultMapConfig.center, defaultMapConfig.zoom)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mapConfig, mapRef, defaultMapConfig])

    const filteredFences = filterFences()
    const filters = prepareFilters();

    return (
        <div className={styles.fenceDashboard}>
            <GFList refreshGeofences={refreshGeofences} groupList={groupList} masters={masters} fenceData={filteredFences} filters={filters} filterData={filterData} fenceTypeIconMap={fenceTypeIconMap} onFilterChange={handleFilterChange} />

            <div className={styles.fenceTypeFilterWrapper}>
                {masters.FENCE_TYPE.map((fenceType, fenceTypeI) => (
                    <button
                        key={`fence_type_${fenceTypeI}`}
                        className={cx(styles.fenceTypeFilterButton, { [styles.selected]: filterData.fenceTypeSelect === fenceType.value })}
                        onClick={() => handleFilterChange({ name: 'fenceTypeSelect', value: fenceType.value })}
                    >
                        <img src={fenceTypeIconMap[fenceType.value]} alt={fenceType.label} />
                        {fenceType.label}
                    </button>
                ))}
            </div>

            <GFMap mapConfig={mapConfig} setMapConfig={setMapConfig} mapRef={mapRef} fenceData={filteredFences} onZoomClick={handleZoomClick} onResetClick={handleResetClick} />
        </div>
    )
}

export default withGeofenceHOC(GFDashboard)